import React from 'react';
import { Link } from 'react-router-dom';

const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || 'sarunashelse@gmail.com';

const SITE_URL =
  process.env.REACT_APP_SITE_URL || 'https://sarunashelse.live';

const LAST_UPDATED = '2026-09-17';

export default function TermsOfUsePage() {
  return (
    <div className="page legal-page">
      <div className="card legal-card">
        <h1>Naudojimo sąlygos</h1>
        <p className="legal-meta">
          Programėlė „Išgerk vaistus“ · Atnaujinta {LAST_UPDATED}
        </p>

        <section>
          <h2>1. Kas mes esame</h2>
          <p>
            Šios sąlygos taikomos mobiliajai programėlei <strong>Išgerk vaistus</strong>{' '}
            ir svetainei{' '}
            <a href={SITE_URL} target="_blank" rel="noopener noreferrer">
              sarunashelse.live
            </a>
            . Kontaktai:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
        </section>

        <section>
          <h2>2. Paslauga</h2>
          <p>
            Programėlė padeda nustatyti vaistų priminimus telefone. Tai nėra
            medicinos paslauga, diagnozė ar gydymo rekomendacija. Dėl vaistų
            vartojimo visada klauskite gydytojo arba vaistininko.
          </p>
        </section>

        <section>
          <h2>3. Paskyra</h2>
          <p>
            Norėdami naudotis Programėle, sukuriate paskyrą el. paštu. Jūs
            atsakote už savo prisijungimo duomenų saugumą. Viena paskyra skirta
            tik jums – negalite naudoti kito asmens paskyros.
          </p>
        </section>

        <section>
          <h2>4. Prenumerata ir mokėjimai</h2>
          <p>
            Po bandomojo laikotarpio Programėlė veikia su mokama prenumerata.
            Mokėjimus apdoroja Stripe. Kainos nurodytos svetainėje ir
            Programėlėje. Prenumeratą galite atšaukti per Stripe klientų
            portalą (Programėlėje: Pagalba → Tvarkyti prenumeratą). Atšaukus,
            prieiga paprastai lieka iki jau apmokėto laikotarpio pabaigos.
          </p>
        </section>

        <section>
          <h2>5. Paskyros ištrynimas</h2>
          <p>
            Paskyrą galite ištrinti Programėlėje (Pagalba → Ištrinti paskyrą)
            arba svetainėje{' '}
            <a href={`${SITE_URL}/delete-account`}>{SITE_URL}/delete-account</a>.
            Jei turite aktyvią ar vis dar apmokestinamą Stripe prenumeratą,
            paskyros ištrinti negalima, kol jos nenutraukiate. Stripe
            finansiniai įrašai lieka Stripe pagal teisės aktus.
          </p>
        </section>

        <section>
          <h2>6. Jūsų turinys</h2>
          <p>
            Jūs įvedate priminimų tekstus ir laikus. Neįveskite kito asmens
            sveikatos duomenų be teisėto pagrindo. Mes nenaudojame jūsų
            priminimų reklamai.
          </p>
        </section>

        <section>
          <h2>7. Privatumas</h2>
          <p>
            Asmens duomenų tvarkymas aprašytas{' '}
            <Link to="/privacy">privatumo politikoje</Link>.
          </p>
        </section>

        <section>
          <h2>8. Atsakomybės ribos</h2>
          <p>
            Programėlė teikiama tokia, kokia yra. Mes neatsakome, jei priminimas
            pavėluoja dėl telefono nustatymų, operacinės sistemos apribojimų,
            interneto ar trečiųjų šalių paslaugų. Nepraleiskite vaistų pasitikėdami
            vien tik programėle.
          </p>
        </section>

        <section>
          <h2>9. Sąlygų pakeitimai</h2>
          <p>
            Sąlygas galime atnaujinti. Naujausia versija skelbiama šiame
            puslapyje.
          </p>
        </section>

        <section>
          <h2>10. Kontaktai</h2>
          <p>
            Klausimais rašykite:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
        </section>

        <p className="legal-back">
          <Link to="/">← Pradžia</Link>
        </p>
      </div>
    </div>
  );
}
